import styled from '@emotion/styled/macro';

export const ProjectCardHeaderForm = styled.form({ flex: '1 0 auto' });
